import OAuth from "../../oauth";
var auth = new OAuth();
export default function (to, from, next) {
  try {
    // Always logout, regardless of current user state
    auth.logout();
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Logout error:', error);
  }

  // Always redirect to login using path
  next('/login');
}